import { invalidateCache } from 'api/urql/helpers/mutation';

export const bulkPost = (results, args, cache, info) => {
  // handlers go here
  invalidateCache('importedDrafts')(results, args, cache, info);
};
